/**
 * 开发者：杜超峰
 */

export default class Event{
    constructor(){
        this._registerList = []
        this._listener = {}
    }

    _err(message){
        let err = new Error('事件错误', `错误：${message}`)
        console.error(err)
    }

    _getRegisterEventIndex(type){
        return this._registerList.indexOf(type);
    }

    eventIsRegister(type){
        let isRegister = false;
        let index = this._getRegisterEventIndex(type)
        if(index > -1){
            isRegister = true
        }
        return isRegister
        
    }

    registerEvent(type){
        let isRegister = this.eventIsRegister(type);
        if(isRegister){
            // this._err(`${type} 已经存在`)
        } else {
            this._registerList.push(type)
            this._listener[type] = []
        }
    }

    unregisterEvent(type){
        let index = this._registerList.indexOf(type);
        if(index > -1){
            this._registerList.splice(index, 1);
            delete this._listener[type]
        }
    }

    on(type, fn){
        if(!fn || !(fn instanceof Function)) {
            this._err(`该监听不是函数`)
        }
        let isRegister = this.eventIsRegister(type);
        if(isRegister){
            let isExist = false
            let fnList = this._listener[type] || []
            for(let i = 0; i < fnList.length; i++){
                let _fn = fnList[i];
                if(fn === _fn){
                    this._err(`函数已是注册到${type}事件中，请不要重复监听`)
                    isExist = true
                    break;
                }
            }
            if(!isExist){
                this._listener[type].push(fn)
            }
        } else {
            this.registerEvent(type)
            this.on(type, fn)
            // this._err(`${type} 未注册，请注册之后再监听`)
        }
    }

    publish(type, ...args){
        let isRegister = this.eventIsRegister(type);
        if(isRegister){
            let fnList = this._listener[type]
            fnList.forEach(fn => {
                fn(...args)
            });
        } else {
            this._err(`${type} 未注册，请注册之后再发布监听`)
        }
    }

    removeListener(type, fn){
        if(!fn || !(fn instanceof Function)) {
            this._err(`该监听不是函数`)
        }
        let isRegister = this.eventIsRegister(type);
        if(isRegister){
            let index = -1
            let fnList = this._listener[type] || []
            for(let i = 0; i < fnList.length; i++){
                let _fn = fnList[i];
                if(fn === _fn){
                    index = i
                    break;
                }
            }
            if(index > -1){
                fnList.splice(index, 1)
            }
        } else {
            this._err(`${type} 未注册`)
        }
    }
}